import React, { useState, useEffect } from 'react';
import { Breadcrumb, Layout, theme, Space, Form, Input, Button, Select, DatePicker, InputNumber, Col, Row, Switch,Spin } from 'antd';
import { AlertError, AlertSuccess } from '../usableclasses.js';
import axios from 'axios';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import { Link, useNavigate } from "react-router-dom";

const { Content } = Layout;

const VendorRegistration = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");

    const [form] = Form.useForm();
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        setLoading(true);
        axios.get(`${ApiURL}/master/counrty/dropdown`, {
            headers: { SystemAccessToken: TOKEN }
        }).then(response => {
            setCountries(response.data);
        }).catch(error => {
            AlertError('Failed to load country list');
        });
        setLoading(false);
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const payload = {
                vendorType: values.vendorType,
                vendorName: values.vendorName,
                vendorRegDocType: values.vendorRegDocType,
                vendorRegCountry: values.vendorRegCountry || "",
                vendorRegNo: values.vendorRegNo,
                vendorTaxNo: values.vendorTaxNo || "",
                vendorAddress: values.vendorAddress,
                vendorOfficeLine: values.vendorOfficeLine,
                vendorHotline: values.vendorHotline || "",
                vendorEmail: values.vendorEmail || "",
                vendorWeb: values.vendorWeb || "",
                vendorRegDate: values.vendorRegDate ? values.vendorRegDate.format('YYYY-MM-DD') : "2025-01-01",
                vendorCurrentBalance: values.vendorCurrentBalance ? values.vendorCurrentBalance.toString() : 0,
                vendorIsVerified: values.vendorIsVerified || false, 
                createdBy: UPDATED_BY
            };

            await axios.post(`${ApiURL}/vendor/create`, payload, {
                headers: { SystemAccessToken: TOKEN }
            });

            AlertSuccess('Vendor registered successfully!');
            form.resetFields();
        } catch (error) {
            AlertError('Vendor registration failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Processing...">
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px' }}>
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item ><Link to={'/master/vendorlist'}>Vendor Management</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Vendor Registration</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
                    <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
                        <div style={{ background: colorBgContainer, padding: 24, borderRadius: borderRadiusLG }}>
                            <h2>Vendor Registration</h2>
                            <Form form={form} layout="vertical" onFinish={onFinish}>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Vendor Type" name="vendorType" rules={[{ required: true, message: ' ${label} is required!',  }]}>
                                            <Select>
                                                <Select.Option value="Person">Person</Select.Option>
                                                <Select.Option value="Business">Business</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={18} style={{ padding: '5px' }}>
                                        <Form.Item label="Vendor Name" name="vendorName" rules={[{ required: true, max: 150, message: ' ${label} is required!',  }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Document Type" name="vendorRegDocType" rules={[{ required: true , message: ' ${label} is required!', }]}>
                                            <Select>
                                                <Select.Option value="NIC">NIC</Select.Option>
                                                <Select.Option value="BR">BR</Select.Option>
                                                <Select.Option value="PASSPORT">Passport</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Registration Country" name="vendorRegCountry" rules={[{ required: true, message: ' ${label} is required!',  }]}>
                                            <Select>
                                                {countries.map((country) => (
                                                    <Select.Option key={country.id} value={country.id}>{country.label}</Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Registration No" name="vendorRegNo" rules={[{ required: true, max: 20, message: ' ${label} is required!',  }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Tax No" name="vendorTaxNo" rules={[{ max: 20 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Hotline" name="vendorHotline" rules={[{ max: 15 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Office Line" name="vendorOfficeLine" rules={[{ required: true, max: 15, message: ' ${label} is required!',  }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Email" name="vendorEmail" rules={[{ type: 'email', max: 150 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Website" name="vendorWeb" rules={[{ max: 150 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={24} style={{ padding: '5px' }}>
                                        <Form.Item label="Address" name="vendorAddress" rules={[{ required: true, max: 200 , message: ' ${label} is required!', }]}>
                                            <Input.TextArea />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Current Balance" name="vendorCurrentBalance" rules={[{ required: true, message: ' ${label} is required!',  }]}>
                                            <InputNumber min={0} step={0.01} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Registration Date" name="vendorRegDate" rules={[{ required: true, message: ' ${label} is required!',  }]}>
                                            <DatePicker format='YYYY-MM-DD' />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Is Verified Customer" name="vendorIsVerified" valuePropName="checked">
                                            <Switch />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px',display:'flex',justifyContent:'flex-end',alignItems:'flex-end' }}>
                                        <Form.Item>
                                            <Button style={{ width: "100%" }} type="primary" htmlType="submit" loading={loading}>
                                                {loading ? "Registering..." : "Register"}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Space>
                </div>
            </Content>
            <Footerdiv />
        </Layout>
        </Spin>
    );
};

export default VendorRegistration;
